import { dateFormat } from "nq-js";
import { useEffect, useState } from "react";

function ExitInterviewPDF({ object, schema, employee }) {
  const [interviewObject, setObject] = useState({});
  const [objectSchema, setSchema] = useState({});
  const [objectEmployee, setEmployee] = useState({});

  useEffect(() => {
    const schemaCopy = { ...schema };
    delete schemaCopy.fields.id;
    delete schemaCopy.fields.created;
    delete schemaCopy.fields.updated;
    delete schemaCopy.fields.acl;

    setSchema(schemaCopy.fields);
    setObject(object || {});
    setEmployee(employee);
  }, [object, schema, employee]);

  const employeeFullName = `${objectEmployee?.firstName || ""} ${
    objectEmployee?.middleName || ""
  } ${objectEmployee?.lastName || ""}`;

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          padding: "1.5rem 2rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img
            src="/lgstop.png"
            alt="LGS Logo"
            className="logo"
            width={180}
            style={{
              alignSelf: "center",
              marginBottom: "1rem",
            }}
          />

          <p style={{ textAlign: "center", margin: "0" }}>
            Office Address: P.E.S. Bldg. 1639 Dian St., San Isidro, Makati City
            Philippines
          </p>
          <p style={{ textAlign: "center" }}>
            Telephone Number: (632) 8889-2680
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h2 style={{ textAlign: "center" }}>EXIT INTERVIEW</h2>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignContent: "center" }}>
              <b>Name:</b>
              <p
                style={{
                  borderBottom: "1px solid black",
                  padding: "0 1rem",
                  margin: 0,
                }}
              >
                {employeeFullName}
              </p>
            </div>

            <div style={{ display: "flex", alignContent: "center" }}>
              <b>Date:</b>
              <p
                style={{
                  borderBottom: "1px solid black",
                  padding: "0 1rem",
                  margin: 0,
                }}
              >
                {dateFormat(object?.created) || ""}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "0.5rem",
            }}
          >
            <div style={{ display: "flex", alignContent: "center" }}>
              <b>Position/Client:</b>
              <p
                style={{
                  borderBottom: "1px solid black",
                  padding: "0 1rem",
                  margin: 0,
                }}
              >
                {`${objectEmployee?.position || ""} / ${
                  objectEmployee?.deployedAt || ""
                }`}
              </p>
            </div>
          </div>

          <div
            style={{
              padding: "0.5rem 2rem",
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              marginTop: "1rem",
            }}
          >
            {Object.keys(objectSchema).map((key, index) => (
              <div
                key={key}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <b style={{ margin: "0" }}>{objectSchema[key]?.label || key}</b>
                <p
                  style={{
                    margin: "0",
                    borderBottom: "0.5px solid #ddd",
                    padding: "1px 0.5rem",
                    marginLeft: "1rem",
                  }}
                >
                  {interviewObject[key]}
                </p>
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "3rem 3rem 0 3rem",
              width: "fit-content",
            }}
          >
            <p
              style={{
                margin: "0",
                width: "fit-content",
                borderBottom: "1px solid black",
                padding: "0 0.5rem",
                textAlign: "center",
              }}
            >
              {employeeFullName.toUpperCase()}
            </p>

            <b style={{ textAlign: "center" }}>Employee Name & Signature</b>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "3rem 3rem 0 3rem",
              width: "fit-content",
            }}
          >
            <b style={{ marginBottom: "1.5rem" }}>Noted By:</b>
            <p
              style={{
                margin: "0",
                borderBottom: "1px solid black",
                padding: "0 0.5rem",
                width: "300px",
                textAlign: "center",
              }}
            ></p>

            <b style={{ textAlign: "center" }}>LGS Representative</b>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExitInterviewPDF;
